import { useTranslation } from 'react-i18next';

import { DiscreteDateLabels } from './types';

export const useDiscreteLabels = (): DiscreteDateLabels => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'common.complexDateInput',
  });

  return {
    directions: {
      past: t('directions.past'),
      next: t('directions.next'),
      this: t('directions.this'),
    },
    granularities: {
      day: t('granularities.day'),
      week: t('granularities.week'),
      month: t('granularities.month'),
      year: t('granularities.year'),
    },
    granularitiesThis: {
      day: t('granularitiesThis.day'),
      week: t('granularitiesThis.week'),
      month: t('granularitiesThis.month'),
      year: t('granularitiesThis.year'),
    },
    directionAriaLabel: t('directionAriaLabel'),
    amountAriaLabel: t('amountAriaLabel'),
    granularityAriaLabel: t('granularityAriaLabel'),
  };
};
